export { default } from './InterfaceContainerTitle';
